<template>
  <div
    v-html="value"
    :id="setId(schema.model)"
    @contextmenu="selectComponentDEV($event, schema.model)"
    :class="[getSelectedDEV && 'dev-selected-component']"
  >
    {{ value }}
  </div>
</template>

<script>
import { abstractField } from 'vue-form-generator';
import devComponentMixin from '@/mixins/dev-component-mixin';

import * as HANDLERS from '@/helpers/types/handlers';

export default {
  mixins: [abstractField, devComponentMixin],
  methods: {
    setId(field) {
      return this.formOptions.mode === 'list' ? `${field}_${this.formOptions.index}` : field;
    }
  }
};
</script>
